import { ShadowKey } from '@pasteltech/theme-provider'

const shadowColor = {
  low: 'rgba(68, 70, 79, 0.15)',
  medium: 'rgba(68, 70, 79, 0.20)',
  high: 'rgba(68, 70, 79, 0.30)',
}

export const colorTheme = {
  primary: {
    main: '#6E707C',
    mainContrast: '#FFFFFF',
    container: '#E7E7E9',
    containerContrast: '#FFFFFF',
  },

  secondary: {
    main: '#18181B',
    mainContrast: '#B0C6FF',
    container: '#C8D1DF',
    containerContrast: '#141B2C',
  },

  tertiary: {
    main: '#C2C9D6',
    mainContrast: '#B0C6FF',
    container: '#9CF0F7',
    containerContrast: '#141B2C',
  },

  container: {
    lowest: '#FFFFFF',
    low: '#FCFCFC',
    medium: '#EEEEEF',
    high: '#33363C',
    highest: '#181818',
    contrast: '#2F3036',
  },

  text: {
    contrast: '#FFFFFF',
    trivial: '#CECED1',
    low: '#C6C6C8',
    medium: '#56565B',
    high: '#36363B',
  },

  border: {
    low: '#E3E3E5',
    high: '#94959B',
  },

  error: {
    main: '#FFFFFF',
    mainContrast: '#690005',
    container: '#FFB4AB',
    containerContrast: '#FFB4AB',
  },

  warning: {
    main: '#FFFFFF',
    mainContrast: '#690005',
    container: '#FFE57B',
    containerContrast: '#FFE57B',
  },

  success: {
    main: '#FFFFFF',
    mainContrast: '#690005',
    container: '#77F492',
    containerContrast: '#77F492',
  },

  shadow: {
    [ShadowKey.low]: [
      {
        horizontal: 0,
        vertical: 1,
        blurRadius: 2,
        spreadRadius: 0,
        color: shadowColor.medium,
      },
      {
        horizontal: 0,
        vertical: 1,
        blurRadius: 3,
        spreadRadius: 1,
        color: shadowColor.low,
      },
    ],
    [ShadowKey.medium]: [
      {
        horizontal: 0,
        vertical: 1,
        blurRadius: 2,
        spreadRadius: 0,
        color: shadowColor.medium,
      },
      {
        horizontal: 0,
        vertical: 2,
        blurRadius: 6,
        spreadRadius: 2,
        color: shadowColor.high,
      },
    ],
    [ShadowKey.high]: [
      {
        horizontal: 0,
        vertical: 4,
        blurRadius: 8,
        spreadRadius: 3,
        color: shadowColor.medium,
      },
      {
        horizontal: 0,
        vertical: 1,
        blurRadius: 3,
        spreadRadius: 0,
        color: shadowColor.high,
      },
    ],
    [ShadowKey.highest]: [
      {
        horizontal: 0,
        vertical: 6,
        blurRadius: 10,
        spreadRadius: 4,
        color: shadowColor.medium,
      },
      {
        horizontal: 0,
        vertical: 2,
        blurRadius: 3,
        spreadRadius: 0,
        color: shadowColor.high,
      },
    ],
  },

  hover: {
    low: 'rgba(56, 92, 166, 0.04)',
    high: 'rgba(73, 69, 79, 0.12)',
  },

  ripple: {
    low: 'rgba(56, 92, 166, 0.2)',
    high: 'rgba(255, 255, 255, 0.12)',
  },

  disabled: 'rgba(117, 119, 128, 0.2)',

  opacity: {
    hover: 0.2,
    selected: 0.4,
    hoverSelected: 0.8,
  },
  background: '#FCFCFC',
  facebook: '#1877F2',
  whatsapp: '#25D366',
} as const
